import { ViewChild, Component, AfterContentInit, ChangeDetectorRef, ElementRef, OnInit, } from '@angular/core';
import { SortingHeadersEnum } from './enums/sorting-headers-enum';
import { filter, merge, Subscription, skip } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { HomeTableDataSource } from './shop-table-datasource';
import { NavigationStart, Router } from '@angular/router';
import { ClinicOfficeListItem } from 'src/shop-manager/common/models/internal/clinic-office-list-item.model';
import { ClinicOfficeListService } from 'src/shop-manager/services/clinic-office-list.service';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { DialogsManagerService } from 'src/shop-manager/services/dialogs-manager.service';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { SortingDirectionsEnum } from 'src/common-panel/enums/sorting-directions-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';


@Component({
    selector: 'app-shop-table',
    templateUrl: './shop-table.component.html',
    styleUrls: ['./shop-table.component.css'],
    standalone: false
})
export class ShopTableComponent implements OnInit, AfterContentInit
{
  subscription: Subscription = new Subscription()


  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatTable) table?: MatTable<ClinicOfficeListService>;


  dataSource: HomeTableDataSource

  ShopTypesEnum = ShopTypesEnum

  displayedColumns = [
    "clinicOfficeId",
    "name",
    "city",
    "brand",
    "hcpAmount",
    "patientsAmount",
    "status",
    "actions",
  ];



  constructor(private dialogsManagerService: DialogsManagerService, private elementRef: ElementRef, private router: Router, private serverValueInterpreterService: ServerValueInterpreterService,
    private clinicOfficeListService: ClinicOfficeListService, private clinicOfficeManageService: ClinicOfficeManageService, private cref: ChangeDetectorRef)
  {
    this.dataSource = new HomeTableDataSource(this.clinicOfficeListService);
  } //private userManageService: UserManageService,private clinicService: ClinicService, private entOfficeService: EntOfficeService

  ngAfterContentInit(): void
  {
    this.cref.detectChanges()
  }

  ngOnInit(): void
  {
    
    if (this.clinicOfficeListService.filterByShopType.value == ShopTypesEnum.clinic)
    {
      this.displayedColumns = [
        "clinicOfficeId",
        "name",
        "city",
        "brand",
        "hcpAmount",
        "patientsAmount",
        "status",
        "actions",
      ];
    } else if (this.clinicOfficeListService.filterByShopType.value == ShopTypesEnum.entOffice)
    {
      this.displayedColumns = [
        "clinicOfficeId",
        "name",
        "city",
        "brand",
        "entAmount",
        "patientsAmount",
        "actions",
      ];
    }

    this.clinicOfficeListService.filterByShopType.pipe(skip(1)).subscribe(l_input =>
    {
      if (l_input == ShopTypesEnum.clinic)
      {
        this.displayedColumns = [
          "clinicOfficeId",
          "name",
          "city",
          "brand",
          "hcpAmount",
          "patientsAmount",
          "status",
          "actions",
        ];
      } else if (l_input == ShopTypesEnum.entOffice)
      {
        this.displayedColumns = [
          "clinicOfficeId",
          "name",
          "city",
          "brand",
          "entAmount",
          "patientsAmount",
          "actions",
        ];
      }
      this.dataSource.loadClinicsOffices();
    })

    this.clinicOfficeListService.filterByShopState.pipe(skip(1)).subscribe(() =>
    {
      this.dataSource.loadClinicsOffices();
    })

    this.clinicOfficeListService.filterByCountry.pipe(skip(1)).subscribe(() =>
    {
      this.dataSource.loadClinicsOffices();
    })

    let l_sub = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() =>
    {
      this.subscription.unsubscribe();
      l_sub.unsubscribe();
      this.dataSource.disconnect();
      this.elementRef.nativeElement.remove();
    });

    let l_sub2 = this.clinicOfficeListService.needsToRefresh.pipe(filter(l_val => l_val == true)).subscribe(() =>
    {
      this.refreshTable()
    })

    this.dataSource.loadClinicsOffices();

    this.subscription.add(l_sub2)
  }


  ngOnDestroy(): void
  {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit()
  {
    let l_sub = this.sort!.sortChange.subscribe(() =>
    {
      this.paginator!.pageIndex = 0;
      this.dataSource.sortDirection = this.sort!.direction as SortingDirectionsEnum;
      this.dataSource.sortingHeader = this.sort!.active as SortingHeadersEnum;
      this.dataSource.sortData()
    });

    let l_sub2 = merge(this.sort!.sortChange, this.paginator!.page).subscribe(() =>
    {
      this.loadClinicsOfficesPage();
    });

    this.subscription.add(l_sub);
    this.subscription.add(l_sub2);
  }


  loadClinicsOfficesPage()
  {

    this.dataSource.pageSize = this.paginator!.pageSize;
    this.dataSource.pageIndex = this.paginator!.pageIndex;
    this.dataSource?.loadClinicsOfficesPage();
  }


  refreshTable()
  {
    this.dataSource?.loadClinicsOffices();
  }

  addClinicOffice()
  {
    this.dialogsManagerService.showCreateClinicOfficeDialogComponent()
  }

  publishClinicOffice(clinicOffice: ClinicOfficeListItem)
  {
    this.clinicOfficeManageService.currentClinicOffice = clinicOffice;
    this.dialogsManagerService.showPublishClinicOfficeDialogComponent()
  }

  showInfoDialog(clinicOffice: ClinicOfficeListItem)
  {
    this.clinicOfficeManageService.currentClinicOffice = clinicOffice;
    this.dialogsManagerService.showInfoClinicOfficeDialogComponent()
  }


  editClinicOffice(clinicOffice: ClinicOfficeListItem)
  {
    this.dialogsManagerService.showEditClinicOfficeDialogComponent()
    this.clinicOfficeManageService.currentClinicOffice = clinicOffice;
  }

  getBrandName(brandId: BrandTypesEnum): string
  {
    return this.serverValueInterpreterService.getBrandName(brandId)
  }
}
